import { render, staticRenderFns } from "./warehouse_list.vue?vue&type=template&id=60da1fce&scoped=true"
import script from "./warehouse_list.vue?vue&type=script&lang=js"
export * from "./warehouse_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da1fce",
  null
  
)

export default component.exports